import Link from 'next/link';
import { SymbolLinkWrapper } from './styled';
import { ReactElement, useCallback } from 'react';

interface SymbolLinkProps {
  symbol: string;
  children: ReactElement | HTMLElement | string | number;
  isPreventDefault: boolean;
  onClick?: (...props) => void;
}

const SymbolLink = ({ symbol, children, isPreventDefault = false, onClick }: SymbolLinkProps) => {
  
  const handleOnClick = useCallback((event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    if (isPreventDefault) {
      event.preventDefault();
    }
    !!onClick && onClick(event);
    return false;
  }, [isPreventDefault, onClick])

  return (
    <Link href={`/symbol/${symbol}`} passHref>
      <SymbolLinkWrapper onClick={handleOnClick}>{children}</SymbolLinkWrapper>
    </Link>
  )
};

export default SymbolLink;
